import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IKeyArray } from 'types/IKeyArray';
import { IModuleOut } from 'types/domain/module';
import { Handles } from 'constants/handles';

const id = (state: RootState, id?: number) => id || state.state[EntityTypes.ACTION_ENTITY];
const modOuts = (state: RootState) => state.entity.present[EntityTypes.MODULE_OUT];

export const selectActionEntityModuleOut = createSelector(
  [modOuts, id],
  (modOuts: IKeyArray<IModuleOut>, id: number) => {
    return Object.values(modOuts).find((m: IModuleOut) => m.status > -1 && m.sourceHandle === id);
  },
);

/**
 * The branch an answer takes of its own — an out wired from that one option.
 *
 * An option wired to the slide the question leads to anyway (its child, else its
 * DEFAULT out) isn't a branch: it goes nowhere the linear path doesn't. Such outs
 * turn up on real quizzes, one per option, and since a per-answer out wins over
 * the correct/wrong handles they sent every answer straight past the answer
 * slides. They're ignored, so the question routes on its result instead.
 */
export function answerModuleOut(
  action: { childId?: number; outs: IKeyArray<IModuleOut> },
  actionEntityId: number,
): IModuleOut {
  const out = actionEntityId != null ? action?.outs?.[actionEntityId] : null;
  if (!out) return null;

  const linearId = action.childId || action.outs[Handles.DEFAULT]?.targetId;

  return out.targetId === linearId ? null : out;
}
